module.exports = __webpack_public_path__ + "img/introduction-platform-ilustra.24c9c5de.png";